import { useCallback, useEffect, useState } from "react";

import { DocumentDataField } from "../../constants";
import { useTaggerActions } from "../../store";
import { IProcessedTag, TaggerDocument } from "../../store/types";

const useDate = (docId: TaggerDocument["id"], tag?: IProcessedTag) => {
  const { changeDocumentData } = useTaggerActions();

  const [value, setValue] = useState<string | null>(null);

  const handleChange = useCallback((value: string | null) => {
    setValue(value);
    changeDocumentData(docId, DocumentDataField.SelectedDate, value);
  }, []);

  useEffect(() => {
    setValue(tag?.date ?? null);
  }, [tag]);

  return {
    value: value,
    loading: false,
    onChange: handleChange
  };
};

export default useDate;
